<template>
  <div>
    <vue-element-loading :active="loading" />

    <b-alert
      :show="show_patient_load_error"
      variant="danger"
    >{{ $t("patient_create.error.retrieve_patient_data") }}</b-alert>
    <b-alert
      :show="show_main_address_load_error"
      variant="danger"
    >{{ $t("patient_create.error.retrieve_patient_address") }}</b-alert>
    <b-alert
      :show="show_unknown_error"
      variant="danger"
    >{{ $t("patient_create.error.unknown_error") }}</b-alert>

    <div class="my-4 title-information text-uppercase">{{ $t('patient_create.account_info') }}</div>
    <b-form @submit="askForMainAddressAndSendForm" ref="patientform" v-if="!loading">
      <b-row>
        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_current_password"
            class="text-left required"
            :label="$t('user_form.password')"
            label-for="input_current_password"
            :invalid-feedback="form_invalid_feedback.current_password"
            :state="form_state.current_password"
          >
            <b-form-input
              id="input_current_password"
              v-model.trim="formuser.current_password"
              type="password"
              autocomplete="on"
              :state="form_state.current_password"
              :placeholder="$t('user_form.password')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_new_password"
            class="text-left required"
            :label="$t('user_form.new_password')"
            label-for="input_new_password"
            :state="form_state.new_password"
          >
            <b-form-input
              id="input_new_password"
              v-model.trim="formuser.new_password"
              type="password"
              :state="form_state.new_password"
              :placeholder="$t('user_form.new_password')"
            ></b-form-input>
            <PasswordHelper
              :password="formuser.new_password"
              :show="formuser.new_password != undefined || form_state.new_password === false"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div class="my-4 title-information text-uppercase">{{ $t('patient_create.contact_info') }}</div>
      <b-row>
        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_firstname"
            class="text-left required"
            :label="$t('patient_create.firstname_label')"
            label-for="input_firstname"
            :invalid-feedback="form_invalid_feedback.firstname"
            :state="form_state.firstname"
          >
            <b-form-input
              id="input_firstname"
              v-model.trim="form.firstname"
              type="text"
              required
              :state="form_state.firstname"
              :placeholder="$t('patient_create.firstname_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_lastname"
            class="text-left required"
            :label="$t('patient_create.lastname_label')"
            label-for="input_lastname"
            :invalid-feedback="form_invalid_feedback.lastname"
            :state="form_state.lastname"
          >
            <b-form-input
              id="input_lastname"
              v-model.trim="form.lastname"
              type="text"
              required
              :state="form_state.lastname"
              :placeholder="$t('patient_create.lastname_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <VBootstrapFormGroup
            name="group_mobile"
            type="phone"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="12"
            label-cols-lg="12"
            label-cols-xl="12"
            required
            :label="$t('patient_create.mobile_label')"
            :invalid_feedback="form_invalid_feedback.mobile"
            :state="form_state.mobile"
            v-model.trim="form.mobile"
          />
        </b-col>
        <b-col cols="12" md="6" class="my-3">
          <VBootstrapFormGroup
            name="group_phone"
            type="phone"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="12"
            label-cols-lg="12"
            label-cols-xl="12"
            required
            :label="$t('patient_create.phone_label')"
            :invalid_feedback="form_invalid_feedback.phone"
            :state="form_state.phone"
            v-model.trim="form.phone"
          />
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_country"
            class="text-left required"
            :label="$t('patient_create.country_label')"
            label-for="input_country"
            :invalid-feedback="form_invalid_feedback.country"
            :state="form_state.country"
          >
            <CountrySelect
              v-model="form.country"
              :country="form.country"
              required
              :topCountry="deviceCountry"
              class="custom-select no-radius-select"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_address"
            class="text-left required"
            :label="$t('patient_create.address_label')"
            label-for="input_address"
            :invalid-feedback="form_invalid_feedback.address"
            :state="form_state.address"
          >
            <b-form-input
              id="input_address"
              v-model.trim="form.address"
              type="text"
              required
              :state="form_state.address"
              :placeholder="$t('patient_create.address_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_colony"
            class="text-left required"
            :label="$t('patient_create.colony_label')"
            label-for="input_colony"
            :invalid-feedback="form_invalid_feedback.colony"
            :state="form_state.colony"
          >
            <b-form-input
              id="input_colony"
              v-model.trim="form.colony"
              type="text"
              required
              :state="form_state.colony"
              :placeholder="$t('patient_create.colony_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_town"
            class="text-left required"
            :label="$t('patient_create.town_label')"
            label-for="input_town"
            :invalid-feedback="form_invalid_feedback.town"
            :state="form_state.town"
          >
            <b-form-input
              id="input_town"
              v-model.trim="form.town"
              type="text"
              required
              :state="form_state.town"
              :placeholder="$t('patient_create.town_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_federal_entity"
            class="text-left required"
            :label="$t('patient_create.federal_entity_label')"
            label-for="input_federal_entity"
            :invalid-feedback="form_invalid_feedback.federal_entity"
            :state="form_state.federal_entity"
          >
            <b-form-input
              id="input_federal_entity"
              v-model.trim="form.federal_entity"
              type="text"
              required
              :state="form_state.federal_entity"
              :placeholder="$t('patient_create.federal_entity_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="my-3">
          <b-form-group
            id="group_postal_code"
            class="text-left required"
            :label="$t('patient_create.postal_code_label')"
            label-for="input_postal_code"
            :invalid-feedback="form_invalid_feedback.postal_code"
            :state="form_state.postal_code"
          >
            <b-form-input
              id="input_postal_code"
              v-model.trim="form.postal_code"
              type="text"
              required
              :state="form_state.postal_code"
              :placeholder="$t('patient_create.postal_code_placeholder')"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col cols="12" md="3">
          <b-button
            type="submit"
            variant="primary"
            size="xl"
          >{{ $t('patient_create.submit_button') }}</b-button>
        </b-col>
      </b-row>
    </b-form>
    <div class="mt-5">
      <b-alert
        :show="show_patient_save_error"
        variant="danger"
      >{{ $t("patient_create.error.save_patient_data") }}</b-alert>
    </div>

    <b-modal
      id="modalUpdateMainAddress"
      ref="ask_update_main_address"
      :title="$t('patient_create.update_main_address')"
      @ok="sendForm(true)"
      @cancel="sendForm(false)"
    ></b-modal>
  </div>
</template>


<script>
import { CountrySelect } from "vue-country-region-select";
import { mapState, mapGetters, mapActions } from "vuex";
import VBootstrapFormGroup from "@/components/VBootstrapFormGroup";
import PasswordHelper from "@/components/PasswordHelper";

export default {
  name: "patient-create-form",
  components: {
    CountrySelect,
    PasswordHelper,
    VBootstrapFormGroup,
  },
  data() {
    return {
      form: {
        firstname: "",
        lastname: "",
        country: "",
        address: "",
        town: "",
        colony: "",
        postal_code: "",
        federal_entity: "",
        mobile: "",
        mobile_extension: "",
        phone: "",
      },
      formuser: {
        current_password: "",
        new_password: "",
      },
      options: [
        { value: null, text: "Please select an option" },
        { value: 1, text: this.$t("patient_create.id_type_passport") },
        { value: 2, text: this.$t("patient_create.id_type_ine") },
      ],
      form_invalid_feedback: {},
      form_state: {},
      show: true,
      options_date: {
        format: "YYYY-MM-DD",
        useCurrent: false,
      },
      main_address: undefined,
      /*
      Propiedades que serán comparadas para decidir si preguntar al usuario
      si quiere copiarlas entre sus datos fiscales y su dirección principal.
      */
      properties: [
        "country",
        "address",
        "town",
        "colony",
        "postal_code",
        "federal_entity",
        "mobile",
        "phone",
      ],
      loading: undefined,
      // marcado como true cuando hay errores durante la obtención
      // de datos
      load_data_errors: false,
      save_data_errors: false,
      // mostrar error si se producen fallos al obtener los datos de paciente
      show_patient_load_error: undefined,
      show_main_address_load_error: undefined,
      show_patient_save_error: undefined,
      show_unknown_error: undefined,
    };
  },
  computed: {
    ...mapState({
      country_fields: (state) => state.siteconf.country_fields,
      current_username: (state) => state.auth.current_username,
    }),
    ...mapGetters("naturalperson", ["getUuidPatientSelected"]),
    ...mapGetters("auth", ["deviceCountry"]),
  },
  fallbackI18n: {
    messages: {
      und: {
        user_form: {
          password: "Password",
          new_password: "New password",
        },
        patient_create: {
          firstname_label: "Firstname",
          firstname_desc: "Firstname",
          firstname_placeholder: "Firstname",
          lastname_label: "Lastname",
          lastname_desc: "Lastname",
          lastname_placeholder: "Lastname",
          mobile_label: "Mobile",
          mobile_desc: "Mobile",
          mobile_placeholder: "Mobile",
          phone_label: "Phone",
          phone_desc: "Phone",
          phone_placeholder: "Phone",
          address_label: "Address",
          address_desc: "Address",
          address_placeholder: "Address",
          town_label: "Tax town",
          town_desc: "Tax town",
          town_placeholder: "Tax town",
          country_label: "Country",
          colony_label: "Tax colony",
          colony_desc: "Tax colony",
          colony_placeholder: "Tax colony",
          postal_code_label: "Tax postal code",
          postal_code_desc: "Tax postal code",
          postal_code_placeholder: "Tax postal code",
          federal_entity_label: "Tax federal entity",
          federal_entity_desc: "Tax federal entity",
          federal_entity_placeholder: "Tax federal entity",
          select_option: "Please select an option",
          id_type_passport: "Passport",
          id_type_ine: "INE",
          submit_button: "Save",
          reset_button: "Reset",
          password_changed: "Password changed",
          account_info: "Account information:",
          contact_info: "Contact information:",
          update_main_address:
            "Do you also want to update your main shipping address with this information?",
          main_address_changed: "Main address changed",
          error: {
            save_patient_data:
              "An error saving your data has found. Please, try again later.",
            unknown_error: "Unknown error found. Please, try again later",
            saving_patientdata: "Error saving data, check form errors.",
            retrieve_patient_data:
              "Cannot retrieve patient data. Please, try again later.",
            retrieve_patient_address:
              "Cannot retrieve patient main address. Please, try again later.",
            change_password: "Error saving password",
          },
        },
      },
    },
  },
  watch: {
    getUuidPatientSelected: function () {
      // hemos eliminado la selección de paciente, por defecto siempre
      // se seleccionará el main patient, pero mantenemos esto aquí
      // por si acaso.
      this.loadAll();
    },
  },
  created() {
    this.loadAll();
  },
  methods: {
    ...mapActions({
      // Si se añaden campos el formuser, (distintos de password), descomentar
      // esto y el call dentro de sendForm
      // PATCH_USER_INFORMATION: "auth/PATCH_USER_INFORMATION",
      CHANGE_PASSWORD: "auth/CHANGE_PASSWORD",
      ME: "auth/ME",
      GET_PATIENT: "naturalperson/GET_PATIENT",
      NEW_PATIENT: "naturalperson/NEW_PATIENT",
      PATCH_PATIENT: "naturalperson/PATCH_PATIENT",
      GET_MAIN_PATIENT: "naturalperson/GET_MAIN_PATIENT",
      PATCH_MAIN_ADDRESS: "naturalperson/PATCH_MAIN_ADDRESS",
      GET_MAIN_ADDRESS: "naturalperson/GET_MAIN_ADDRESS",
    }),
    loadAll: function () {
      this.loading = true;
      // vamos a hacer una serie de llamadas a la api, guardamos
      // los promise aquí para después validar que todas se han cumplido
      let promises = [];

      // Obtenemos los datos del usuario (authx.User)
      const request_user_promise = this.ME();
      promises.push(request_user_promise);
      request_user_promise.then((res) => {
        this.formuser = res.data;
      });

      if (
        this.getUuidPatientSelected &&
        this.$route.params.pt_uuid != undefined
      ) {
        // Obtenemos los datos del paciente (naturalperson.Patient)
        // si se ha indicado en la url un uuid y existe un paciente
        // seleccionado, ya que si no existe ninguno significa que
        // no hay ningún paciente en backend y este form se utiliza
        // para crear uno.
        const request_patient_data = this.GET_PATIENT({
          pt_uuid: this.$route.params.pt_uuid,
        });
        promises.push(request_patient_data);
        request_patient_data.then(
          (res) => {
            this.form = res.data;
          },
          () => {
            this.load_data_errors = true;
            this.show_patient_load_error = true;
          }
        );

        // Obtenemos el main address.
        const request_main_address = this.GET_MAIN_ADDRESS({
          pt_uuid: this.$route.params.pt_uuid,
        }).then((res) => {
          this.main_address = res.data;
        });
        // aquí no mostramos error si no podemos obtener el main address,
        // es posible que algunos usuarios no tengan main address a pesar
        // de tener paciente. En este caso, si se actualiza el paciente, en
        // backend se crea un main address si en los datos enviados
        // se coloca upsert_main_address=true. Esto se coloca a true
        // si existe un paciente, pero no se ha podido obtener un main
        // address
        promises.push(request_main_address);
      }

      Promise.all(promises)
        .then(() => {
          // todas las promesas OK
          this.loading = false;
        })
        .catch((err) => {
          // error en alguna promesa
          // si el error es un 404, lo ignoramos, se trata
          // del main addres. No nos importa que no exista porque
          // se va a crear en la creación de paciente o en la actualización.
          // Si no se crea un address, tampoco importa, en el checkout
          // del carrito se mostrará un form para crear una dirección.
          if (err.response) {
            if (err.response.status != 404) {
              if (!this.load_data_errors) {
                this.load_data_errors = true;
                this.show_unknown_error = true;
              }
            }
          }
          this.$sentry({ capture: err });
          this.loading = false;
        });
    },
    // utilizamos un método intermedio porque queremos que el evento
    // submit del formulario se lanze y se ejecuten las validaciones
    // en frontend de datos requeridos.
    // Si las validaciones pasan, se ejecuta este método.
    // Además, con un método intermedio siempre obtenemos un evento submit
    // para poder gestionar preventDefault() de forma correcta
    askForMainAddressAndSendForm(evt) {
      evt.preventDefault();
      if (this.shoudUpdateMainAddress()) {
        // Este modal llamará a sendForm()
        this.$refs.ask_update_main_address.show();
      } else {
        this.sendForm(false);
      }
    },
    sendForm(update_main_address) {
      this.loading = true;
      // ocultamos el modal que pregunta si queremos actualizar el main
      // address
      this.$refs.ask_update_main_address.hide();

      // vamos a hacer una serie de peticiones, guardamos todas las promises
      // aquí para gestionar más adelante que todas las peticiones se han
      // realizado correctamente
      let promises = [];

      // Actualizamos el main address del paciente si éste lo ha indicado
      // expresamente o si no hay ningún main address asociado al
      // paciente.
      if (update_main_address || !this.main_address) {
        this.form.upsert_main_address = true;
      } else {
        this.form.upsert_main_address = false;
      }

      // ************** Gestiones relativas a los datos de paciente
      // **********************************************************************
      // Datos de paciente (form principal), modelo Patient.
      // Con respecto al main address, se actualizara (o no) con esta consulta
      // mediante el valor de this.form.upsert_main_address. El serializer
      // de paciente permite actualizar el main address si se coloca a true
      // en caso de estar creando un paciente en lugar de actualizarlo, SIEMPRE
      // se creará un main address
      let upsert_patient_promise = undefined;
      if (!this.form.uuid) {
        upsert_patient_promise = this.NEW_PATIENT({ data: this.form });
      } else {
        upsert_patient_promise = this.PATCH_PATIENT({
          data: this.form,
          pt_uuid: this.form.uuid,
        });
      }
      promises.push(upsert_patient_promise);
      upsert_patient_promise.then(
        (res) => {
          // colocamos el uuid del paciente, si se le vuelve a dar
          // a guardar de nuevo, no creará uno, sino que actualizará
          // este
          this.form.uuid = res.data.uuid;
          this.$store.commit("naturalperson/MUTATE_MAIN_PATIENT", res.data);
        },
        (err) => {
          this.save_data_errors = true;
          this.show_patient_save_error = true;
          this.$sentry({ capture: err });
          this.putFormFeedback(err.response);
        }
      );

      // ************** Gestiones relativas a la actualización de password
      // **********************************************************************
      // Cambio de contraseña (si se han introducido datos), modelo User
      // si se han introducido datos en cualquiera de los campos, mandamos
      // la petición. De este modo, si uno de los campos se deja vacío,
      // se muestra feedback del error (campo requerido). Dado que estos
      // dos campos no tienen el prop required=true, se saltará los
      // validadores de front.
      if (this.formuser.new_password || this.formuser.current_password) {
        const change_pass_promise = this.CHANGE_PASSWORD({
          new_password: this.formuser.new_password,
          current_password: this.formuser.current_password,
        });
        promises.push(change_pass_promise);
        change_pass_promise.then(undefined, (err) => {
          this.putFormFeedback(err.response);
        });
      }

      // ************** Gestiones relativas al User que no sean password
      // como por ejemplo los checkbox de recibir ofertas o suscribirse al
      // newsletter
      // **********************************************************************
      // Los checkbox de recibir ofertas o suscribirse al newsletter,
      // esto va al modelo User.
      // UPDATE: Estos checkbox han sido eliminados, en caso de añadir datos
      // campos al formulario de formuser (distintos del password), descomentar
      // esto para guardar los datos.
      // const patch_user_info = this.PATCH_USER_INFORMATION(this.formuser);
      // promises.push(patch_user_info);

      // *********** Gestión global de todas las peticiones
      // **********************************************************************
      // Si todo ha ido guay, aún obtenemos el main address. Esto es importante
      // porque este componente no redirecciona a ningún sitio, debe ser el
      // padre quién lo haga. En caso de que una redirección no se complete,
      // queremos tener los datos del main address para determinar si es
      // necesario actualizarlos o no
      Promise.all(promises)
        .then(() => {
          // Todas las promesas OK, obtenemos una última cosa, el main_address
          this.GET_MAIN_ADDRESS({ pt_uuid: this.form.uuid }).then(
            (res) => {
              this.main_address = res.data;
              this.loading = false;
              // En este punto todo ha ido como la seda, emitimos un
              // evento para comunicárselo al padre. Sería interesante
              // que el padre llamáse a naturalperson.GET_MAIN_PATIENT
              // una vez recibido este evento ya que este componente
              // modifica el main patient.
              this.$emit("patient-data-updated", this.form);
            },
            (err) => {
              this.show_main_address_load_error = true;
              this.load_data_errors = true;
              this.showResponseError(err);
              this.$sentry({ capture: err });
              this.loading = false;
            }
          );
        })
        .catch((err) => {
          // Aunque se haya producido un error, aún intentamos obtener
          // el main address si tenemos el main patient
          if (this.form.uuid) {
            this.GET_MAIN_ADDRESS({ pt_uuid: this.form.uuid }).then(
              () => {
                this.show_main_address_load_error = true;
                this.load_data_errors = true;
                this.loading = false;
              },
              () => {
                this.loading = false;
              }
            );
          }
          // TODO: mostrar error
          this.$sentry({ capture: err });
        });
    },
    showModal() {
      this.$refs.ask_update_main_address.show();
    },
    shoudUpdateMainAddress() {
      if (!this.main_address) {
        return false;
      }
      var data = this.form;
      for (var i = 0; i < this.properties.length; i += 1) {
        if (this.main_address[this.properties[i]] != data[this.properties[i]]) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.title-information {
  font-size: $font-size-small * 1.3;
  color: $gray-900;
}
</style>
